import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/branches`, {params})
    },
    create(params) {
        return Vue.axios.post(`/branches/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/branches/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/branches/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/branches/${id}`)
    },
    terminalGroups() {
        return Vue.axios.get(`/terminal-groups`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
